import axios from 'axios';
import * as jsonpatch from 'fast-json-patch';

const CancelToken = axios.CancelToken;
let cancel;

export async function HandleAddTeacher(teacher) {
    const url = 'api/exlTeacherFront/addTeacher/';

    const res = await axios.post(url, teacher).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    data: null,
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                data: null,
            };
        }
    );

    return res;
}

export async function HandleRemoveTeacher(teacherId) {
    const url = 'api/exlTeacherFront/removeTeacher/';
    const query = { teacherId: teacherId };

    const response = await axios.delete(url, { params: query }).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, teacher: response.data, status: response.status };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    teacher: null,
                    status: response.status
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                teacher: null,
                status: error.response.status
            };
        }
    );
    return response;
}

export async function HandlePatchTeacher(initialTeacher, newTeacher) {
    const patch = jsonpatch.compare(initialTeacher, newTeacher);
    let newPatch = [];

    patch.forEach((operation) =>{
        var op = operation;
        op.oldValue = jsonpatch.getValueByPointer(initialTeacher, op.path);

        newPatch.push(op);
    });

    
    const url = 'api/exlTeacherFront/patchTeacher/';
    const body = {
        id: initialTeacher.id,
        EntityId: initialTeacher.id,
        serializedPatch: JSON.stringify(newPatch),
    };

    const response = await axios.put(url, body).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, teacher: response.data };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    teacher: null,
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                teacher: null,
            };
        }
    );

    return response;
}

export async function GetTeacherById(teacherId) {
    const uri = `api/exlTeacherFront/getTeacherById/`;
    const params = {
        teacherId,
    };

    const res = await axios.get(uri, { params }).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return { success: false, error: response.data.message, data: null };
            }
        },
        (error) => {
            return { success: false, error: 'Det gick inte att hämta datan, vänligen kontakta alltid@consid.se.', data: null };
        }
    );
    return res.data;
}

export async function GetTeachersByIds(teacherIds) {
    const uri = `api/exlTeacherFront/getTeachersByIds`;

    const res = await axios.post(uri, teacherIds).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return { success: false, error: response.data.message, data: null };
            }
        },
        (error) => {
            return { success: false, error: 'Det gick inte att hämta datan, vänligen kontakta alltid@consid.se.', data: null };
        }
    );
    return res.data;
}

export async function GetAllTeachers() {
    const uri = `api/exlTeacherFront/getAllTeachers/`;

    const res = await axios.get(uri).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return { success: false, error: response.data.message, data: null };
            }
        },
        (error) => {
            return { success: false, error: 'Det gick inte att hämta datan, vänligen kontakta alltid@consid.se.', data: null };
        }
    );
    return res.data;
}

export async function GetTeachers(pageSize, currentPage, direction, columnName, filters) {
    const uri = `api/exlTeacherFront/getTeachers/`;
    const params = {
        pageSize: pageSize,
        currentPage: currentPage,
        sortDirection: direction,
        sortColumn: columnName,
        filters: filters,
    }

    const res = await axios.get(uri, { params }).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return { success: false, error: response.data.message, data: null };
            }
        },
        (error) => {
            return { success: false, error: 'Det gick inte att hämta datan, vänligen kontakta alltid@consid.se.', data: null };
        }
    );
    return res.data;
}